export const journalEntries = [
  {
    id: 'from-survival-to-sustainability',
    title: 'From Survival To Sustainability: A Study of Continuity, Institutional Memory, and Artist Livelihoods in Kenyas Theatre Ecosystem',
    researchArea: 'Theatre Sustainability',
    abstract: 'An ongoing study investigating artist livelihoods, knowledge transfer, documentation, and institutional continuity within Kenya\'s theatre ecosystem.',
    body: [
      'This ongoing study investigates the historical and contemporary conditions shaping the sustainability of theatre practice in Kenya. While Kenya has produced generations of actors, directors, playwrights, producers, educators, and cultural institutions, limited attention has been paid to how artistic knowledge, professional experience, and cultural value are preserved, transferred, and accumulated across time.',
      'The research asks a central question: How can Kenya\'s theatre ecosystem move from a model of survival, where artists repeatedly rebuild careers and systems from scratch, towards a model of sustainability, where knowledge, mentorship, institutions, and artistic legacies are intentionally preserved and strengthened?',
      'Drawing on historical research, practitioner interviews, oral histories, and sector-wide questionnaires, the study examines critical areas including artist livelihoods, the transition from school and university theatre into professional practice, mentorship and intergenerational knowledge transfer, documentation and archives, regional theatre development, accessibility and inclusion, and the broader systems required to sustain theatre as a lifelong artistic practice.',
      'The study pays particular attention to voices across generations of Kenyan theatre practitioners, recognising senior artists as living archives whose experiences provide insight into the evolution of theatre from pre-independence traditions, post-independence cultural movements, periods of political censorship, and contemporary independent practice.',
      'The research is informed by theories of cultural production and explores how artistic, social, and institutional capital can be preserved and transformed into sustainable ecosystems for future generations.'
    ],
    keyQuestions: [
      'How can Kenya\'s theatre ecosystem move from survival to sustainability?',
      'How are artistic knowledge, professional experience, and cultural value preserved and transferred across generations?',
      'What systems are required to sustain theatre as a lifelong artistic practice?',
      'How can mentorship and institutional memory be strengthened in Kenya\'s theatre sector?'
    ],
    resources: [
      {
       
      }
    ],
    // No gallery images for this entry (in progress)
  },
  {
    id: 'fichua-pazia-research',
    title: 'Fichua Pazia Research',
    researchArea: 'Industry Safeguarding',
    abstract: 'Policy research, safeguarding framework development, and implementation strategies for safer creative workspaces in Kenya.',
  },
  {
    id: 'msichana-wa-ai',
    title: 'Msichana wa AI: Culture, AI and Storytelling',
    researchArea: 'African Women in AI',
    abstract: 'Examining how African women navigate, influence, and are impacted by technological innovation and AI.',
  },
  {
    id: 'neuroarts',
    title: 'NeuroArts',
    researchArea: 'Neurodivergence & Creative Practice',
    abstract: 'Exploring the intersection of neurodivergence and artistic expression in the Kenyan creative sector.',
  }
];